module.exports = "/foodslaboEf/img/ProgressBanner/decoration-background.png";